// auth.js
export const LOGOUT = 'LOGOUT'
export const SAVE_TOKEN = 'SAVE_TOKEN'
export const FETCH_USER = 'FETCH_USER'
export const FETCH_USER_SUCCESS = 'FETCH_USER_SUCCESS'
export const FETCH_USER_FAILURE = 'FETCH_USER_FAILURE'
export const UPDATE_USER = 'UPDATE_USER'

// lang.js
export const SET_LOCALE = 'SET_LOCALE'


// clinician

export const GET_PATIENTS = 'GET_PATIENTS'
export const GET_PATIENTS_ISSUES = 'GET_PATIENTS_ISSUES'
export const GET_PATIENT_COUNT = 'GET_PATIENT_COUNT'
export const GET_CONSENTED_COUNT = 'GET_CONSENTED_COUNT'
export const GET_PATIENT = 'GET_PATIENT'
export const GET_PATIENT_OVERVIEW = 'GET_PATIENT_OVERVIEW'
export const GET_QUESTIONNAIRE_DATA = 'GET_QUESTIONNAIRE_DATA'
export const UPDATE = 'UPDATE'
export const UPDATE_RECORD = 'UPDATE_RECORD'
export const UPDATE_ERRORS = 'UPDATE_ERRORS'
export const SET_RECORDS = 'SET_RECORDS'
export const SAVE_QUESTIONNAIRE_RECORDS = 'SAVE_QUESTIONNAIRE_RECORDS'
export const GET_PATIENT_PERIOD_OVERVIEW = 'GET_PATIENT_PERIOD_OVERVIEW'
export const SAVE_ENTRY_DATE = 'SAVE_ENTRY_DATE'
export const SAVE_PATIENT = 'SAVE_PATIENT'

export const GET_QUESTIONNAIRES = 'GET_QUESTIONNAIRES'
export const GET_PATIENT_SITE = 'GET_PATIENT_SITE'

export const LOGIN_AS_PATIENT = 'LOGIN_AS_PATIENT'

export const SET_PERIOD = 'SET_PERIOD'
export const UPDATE_PERIOD_DATES = 'UPDATE_PERIOD_DATES'


export const GET_MESSAGE_NOTIFICATIONS = 'GET_MESSAGE_NOTIFICATIONS'
export const GET_CONVERSATION = 'GET_CONVERSATION'
export const GET_MESSAGE_STUBS = 'GET_MESSAGE_STUBS'
export const SEND_MESSAGE = 'SEND_MESSAGE'
export const INSERT_MESSAGE = 'INSERT_MESSAGE'
export const GET_RECIPIENT = 'GET_RECIPIENT'
export const INSERT_NOTIFICATION = 'INSERT_NOTIFICATION'
